module.exports = __webpack_public_path__ + "img/newstop_bg.5d56b187.jpg";